import React from 'react';
import { ShoppingCartIcon, CreditCardIcon, DownloadIcon } from 'lucide-react';
export function HowToReceive() {
  const steps = [{
    num: '1',
    title: 'Comprás',
    desc: 'Elegí tu plan y hacé click en el botón de compra.',
    icon: ShoppingCartIcon
  }, {
    num: '2',
    title: 'Pagás',
    desc: 'Completá el pago seguro en segundos.',
    icon: CreditCardIcon
  }, {
    num: '3',
    title: 'Descargás',
    desc: 'Recibís el link de descarga directo a tu email.',
    icon: DownloadIcon
  }];
  return <section className="bg-[#071A14] py-4 md:py-6 px-3 border-b border-[#1F3D2B]" data-id="element-93">
      <div className="max-w-3xl mx-auto" data-id="element-94">
        <h2 className="text-lg md:text-xl font-black text-white text-center mb-4 uppercase tracking-tight" data-id="element-95">
          📩 ¿Cómo recibís el material?
        </h2>
        <div className="flex flex-row items-start justify-center gap-3 md:gap-6" data-id="element-96">
          {steps.map((step, i) => <div key={i} className="flex flex-col items-center text-center flex-1 max-w-[160px]" data-id="element-97">
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-[#102A1F] border border-[#D4A843] flex items-center justify-center mb-2 shadow-lg" data-id="element-98">
                <step.icon className="w-5 h-5 md:w-6 md:h-6 text-[#D4A843]" strokeWidth={2.5} data-id="element-99" />
              </div>
              <span className="text-[#D4A843] font-black text-lg md:text-xl leading-none" data-id="element-100">
                {step.num}
              </span>
              <span className="font-black text-white text-xs md:text-sm uppercase mt-1" data-id="element-101">
                {step.title}
              </span>
              <p className="text-[#BFC9C5] text-[10px] md:text-xs font-bold mt-1 leading-tight" data-id="element-102">
                {step.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}